<c-container class="py-4" style="max-width: 860px;">
  <h2 class="mb-1">{{ 'mycards.title' | translate }}</h2>
  <p class="text-medium-emphasis">{{ 'mycards.subtitle' | translate }}</p>

  <div *ngIf="error()" class="alert alert-danger">{{ error() }}</div>

  <!-- Laden -->
  <div *ngIf="viewState() === 'loading'" class="text-center py-5">
    <c-spinner></c-spinner>
  </div>

  <!-- Kartenpartner-Programm (fac3less + mnlo, auf beiden identisch). Mit Anspruch:
       Link ins Partnerportal — der Partner kennt den User nur über seine E-Mail-Adresse,
       darum steht sie ausdrücklich daneben. Ohne Anspruch: Karten gibt es nur auf
       fac3less, der Button geht per Cross-Login direkt in den Bestellassistenten. -->
  <ng-container *ngIf="cardPartner() as partner">
    <c-card *ngIf="partner.entitled" class="mb-3">
      <c-card-header><strong>{{ 'mycards.partner_title' | translate }}</strong></c-card-header>
      <c-card-body>
        <p>{{ 'mycards.partner_intro' | translate }}</p>
        <p>
          {{ 'mycards.partner_login_hint' | translate }}
          <strong class="text-nowrap">{{ partner.login_email }}</strong>
        </p>
        <a cButton color="primary" [href]="partner.portal_url" target="_blank" rel="noopener">
          {{ 'mycards.partner_open' | translate }}
        </a>
      </c-card-body>
    </c-card>

    <c-card *ngIf="!partner.entitled" class="mb-3">
      <c-card-body class="text-center py-5">
        <div class="fs-1 mb-2">💳</div>
        <h5>{{ 'mycards.partner_not_entitled_title' | translate }}</h5>
        <p class="text-medium-emphasis">
          {{ (partner.purchase_on_site ? 'mycards.partner_not_entitled_here' : 'mycards.partner_not_entitled_text') | translate }}
        </p>
        <button cButton color="primary" [disabled]="busy() === 'buy'" (click)="buyCard()">
          <c-spinner *ngIf="busy() === 'buy'" size="sm" class="me-1"></c-spinner>
          {{ (partner.purchase_on_site ? 'order_products' : 'mycards.partner_buy') | translate }}
        </button>
      </c-card-body>
    </c-card>

    <!-- What the card partner holds about the member (status, cards, deposit
         addresses, transactions), mirrored into our DB by the backend. -->
    <app-card-partner-data [entitled]="partner.entitled"></app-card-partner-data>
  </ng-container>

  <!-- Coming soon (ViaCarte nicht konfiguriert / VIACARTE_API_KEY nicht gesetzt).
       Auf Boards mit Kartenpartner-Programm sagt der Kasten darüber schon alles. -->
  <c-card *ngIf="(viewState() === 'coming_soon' || viewState() === 'start') && !cardPartner()">
    <c-card-body class="text-center py-5">
      <div class="fs-1 mb-2">🚧</div>
      <h5>{{ 'mycards.coming_soon_title' | translate }}</h5>
      <p class="text-medium-emphasis mb-0">{{ 'mycards.coming_soon_text' | translate }}</p>
    </c-card-body>
  </c-card>

  <!-- Nicht berechtigt (nur globalhealth — fac3less/mnlo zeigen stattdessen den Kaufen-Kasten) -->
  <c-card *ngIf="viewState() === 'not_eligible' && !cardPartner()">
    <c-card-body class="text-center py-5">
      <div class="fs-1 mb-2">🔒</div>
      <h5>{{ 'mycards.not_eligible_title' | translate }}</h5>
      <p class="text-medium-emphasis mb-0">
        {{ (data()?.app === 'globalhealth' ? 'mycards.not_eligible_globalhealth' : 'mycards.not_eligible_fac3less') | translate }}
      </p>
    </c-card-body>
  </c-card>

  <!-- Profil unvollständig -->
  <c-card *ngIf="viewState() === 'profile_incomplete'">
    <c-card-header><strong>{{ 'mycards.complete_profile_title' | translate }}</strong></c-card-header>
    <c-card-body>
      <p>{{ 'mycards.complete_profile_intro' | translate }}</p>
      <ul>
        <li *ngFor="let f of data()?.missing_fields">{{ 'mycards.field_' + f | translate }}</li>
      </ul>
      <button cButton color="primary" (click)="goToProfile()">
        {{ 'mycards.go_to_profile' | translate }}
      </button>
      <button cButton color="secondary" variant="outline" class="ms-2" (click)="load()">
        {{ 'mycards.recheck' | translate }}
      </button>
    </c-card-body>
  </c-card>

  <!-- KYC starten (deactivated) -->
  <c-card *ngIf="false">
    <c-card-header><strong>{{ 'mycards.start_title' | translate }}</strong></c-card-header>
    <c-card-body>
      <p>{{ 'mycards.start_intro' | translate }}</p>
      <div class="mb-3" style="max-width: 360px;">
        <label class="form-label">{{ 'mycards.occupation' | translate }}</label>
        <input cFormControl
               [placeholder]="'mycards.occupation_placeholder' | translate"
               [ngModel]="occupation()" (ngModelChange)="occupation.set($event)" />
        <small class="text-medium-emphasis">{{ 'mycards.occupation_hint' | translate }}</small>
      </div>
      <button cButton color="primary" [disabled]="busy() === 'start'" (click)="startKyc()">
        <c-spinner *ngIf="busy() === 'start'" size="sm" class="me-1"></c-spinner>
        {{ 'mycards.start_button' | translate }}
      </button>
    </c-card-body>
  </c-card>

  <!-- KYC läuft – Statusseite -->
  <c-card *ngIf="viewState() === 'status'">
    <c-card-header class="d-flex align-items-center">
      <strong class="me-auto">{{ 'mycards.status_title' | translate }}</strong>
      <c-badge [color]="statusColor(data()?.viacarte?.status)">
        {{ ('viacarte_status.' + data()?.viacarte?.status) | translate }}
      </c-badge>
    </c-card-header>
    <c-card-body>
      <div *ngIf="data()?.viacarte?.failed" class="alert alert-danger">
        {{ 'mycards.status_failed' | translate }}
      </div>
      <div *ngIf="data()?.viacarte?.action_required" class="alert alert-warning">
        {{ 'mycards.status_action_required' | translate }}
      </div>
      <p *ngIf="!data()?.viacarte?.failed && !data()?.viacarte?.action_required" class="text-medium-emphasis">
        {{ 'mycards.status_in_progress' | translate }}
      </p>

      <a *ngIf="data()?.viacarte?.workflow_url" cButton color="primary" class="me-2"
         [href]="data()?.viacarte?.workflow_url" target="_blank" rel="noopener">
        {{ 'mycards.open_workflow' | translate }}
      </a>
      <button cButton color="secondary" variant="outline" [disabled]="busy() === 'refresh'" (click)="refreshStatus()">
        <c-spinner *ngIf="busy() === 'refresh'" size="sm" class="me-1"></c-spinner>
        {{ 'mycards.refresh' | translate }}
      </button>
      <p class="text-medium-emphasis small mt-3 mb-0">{{ 'mycards.auto_refresh_hint' | translate }}</p>
    </c-card-body>
  </c-card>

  <!-- Fertig – Karten -->
  <ng-container *ngIf="viewState() === 'completed'">
    <c-card class="mb-3" *ngIf="accountBalance() as bal">
      <c-card-body class="d-flex flex-wrap align-items-center gap-3 py-3">
        <div class="me-auto text-medium-emphasis">{{ 'mycards.balance' | translate }}</div>
        <div class="text-end">
          <div class="fs-3 fw-semibold">{{ formatAmount(bal.availableBalanceAmount, bal.balanceCurrency) }}</div>
        </div>
      </c-card-body>
    </c-card>

    <c-card>
      <c-card-header><strong>{{ 'mycards.cards_title' | translate }}</strong></c-card-header>
      <c-card-body>
        <div *ngIf="hasInactivePhysical()" class="alert alert-info">
          {{ 'mycards.activation_hint' | translate }}
        </div>
        <div *ngIf="cards().length === 0" class="text-medium-emphasis">{{ 'mycards.no_cards' | translate }}</div>
        <c-row *ngIf="cards().length" class="g-3">
          <c-col [md]="6" *ngFor="let c of cards()">
            <c-card class="h-100">
              <c-card-body>
                <div class="d-flex align-items-center mb-2">
                  <c-badge [color]="c.card_type_label === 'physical' ? 'success' : 'primary'" class="me-2">
                    {{ ('mycards.type_' + c.card_type_label) | translate }}
                  </c-badge>
                  <c-badge [color]="cardStatusBadge(c)">{{ cardStatusLabel(c) }}</c-badge>
                </div>
                <div class="fs-5"><code>•••• {{ c.last_four || '????' }}</code></div>
                <div class="text-medium-emphasis small" *ngIf="c.expiry">{{ 'mycards.expiry' | translate }}: {{ c.expiry }}</div>
                <div class="mt-2">
                  <span class="text-medium-emphasis small">{{ 'mycards.available' | translate }}: </span>
                  <span class="fw-semibold">{{ cardAvailable(c) }}</span>
                </div>
              </c-card-body>
            </c-card>
          </c-col>
        </c-row>
      </c-card-body>
    </c-card>

    <c-card class="mt-3">
      <c-card-header><strong>{{ 'mycards.transactions' | translate }}</strong></c-card-header>
      <c-card-body>
        <div *ngIf="transactions().length === 0" class="text-medium-emphasis">{{ 'mycards.no_transactions' | translate }}</div>
        <table *ngIf="transactions().length" cTable [responsive]="true" [small]="true" class="align-middle mb-0">
          <thead>
            <tr>
              <th>{{ 'mycards.tx_date' | translate }}</th>
              <th>{{ 'mycards.tx_description' | translate }}</th>
              <th>{{ 'mycards.tx_card' | translate }}</th>
              <th class="text-end">{{ 'mycards.tx_amount' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let t of pagedTransactions()">
              <td class="small text-nowrap">{{ formatDate(t.date) }}</td>
              <td>
                {{ t.description || '—' }}
                <c-badge *ngIf="t.pending" color="warning" class="ms-1">{{ 'mycards.tx_pending' | translate }}</c-badge>
              </td>
              <td class="text-nowrap">
                <span *ngIf="t.kind === 'card'">
                  <c-badge [color]="t.card_type_label === 'physical' ? 'success' : 'primary'">
                    {{ ('mycards.type_' + (t.card_type_label || 'card')) | translate }}
                  </c-badge>
                  <code class="small ms-1" *ngIf="t.card_last4">••••{{ t.card_last4 }}</code>
                </span>
                <span *ngIf="t.kind !== 'card'" class="text-medium-emphasis">—</span>
              </td>
              <td class="text-end text-nowrap">{{ formatAmount(t.amount, t.currency || accountCurrency()) }}</td>
            </tr>
          </tbody>
        </table>

        <div *ngIf="transactions().length" class="d-flex flex-wrap align-items-center gap-2 mt-3">
          <div class="d-flex align-items-center gap-1">
            <span class="text-medium-emphasis small">{{ 'mycards.per_page' | translate }}</span>
            <select cSelect class="w-auto" [ngModel]="txPageSize()" (ngModelChange)="setTxPageSize($event)">
              <option *ngFor="let s of txPageSizes" [ngValue]="s">{{ s }}</option>
            </select>
          </div>
          <div class="ms-auto d-flex align-items-center gap-2" *ngIf="txTotalPages() > 1">
            <button cButton color="secondary" variant="outline" size="sm"
                    [disabled]="txPage() <= 1" (click)="txGoTo(txPage() - 1)">‹</button>
            <span class="small text-medium-emphasis">{{ txPage() }} / {{ txTotalPages() }}</span>
            <button cButton color="secondary" variant="outline" size="sm"
                    [disabled]="txPage() >= txTotalPages()" (click)="txGoTo(txPage() + 1)">›</button>
          </div>
        </div>
      </c-card-body>
    </c-card>
  </ng-container>
</c-container>
